import React, { Component } from 'react';
import './App.css';
import EshopApp from './component/EshopApp';

class App extends Component {
  render() {
    return (
      <div className="container">
        <EshopApp />
      </div>
    );
  }
}

export default App;
